import { Box, Typography } from "@mui/material";

interface ShowAllToggleProps {
  showAll: boolean;
  totalCount: number;
  onToggle: () => void;
}

const ShowAllToggle = ({
  showAll,
  totalCount,
  onToggle,
}: ShowAllToggleProps) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 1.5,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }}
      onClick={onToggle}
    >
      <Typography
        variant="body2"
        sx={{
          color: "primary.main",
          fontWeight: 500,
        }}
      >
        {showAll ? "Show less" : `Show all (${totalCount})`}
      </Typography>
    </Box>
  );
};

export default ShowAllToggle;
